import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";

const Relaxation28 = () => {
  return (
    <section className="bg-[#F5F5F5] h-screen shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md">
      {/*Main section*/}
      <main className="px-6 py-6  rounded-lg border mt-6 mb-6  mr-12 ">
        <div className="mt-6 mb-6 flex flex-col items-center">
          <div>
            <h1 className="text-[30px] font-bold text-[#314C1C]">RELAXATION</h1>
            <div className="pt-4">
              <h2 className="text-[18px] font-semibold">EXERCISE PAUSED</h2>
            </div>
            <div className="pt-4">
              <p>
                Take a moment to relax and breathe. When you are ready, click
                'Resume' to continue the exercise.
              </p>
            </div>
          </div>
          <div className="w-96 flex justify-center items-center">
            <img
              src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178818/bcr5ui1l9mwmql6ev4f7.png"
              alt
              className="w-full max-w-screen-xl"
            />
          </div>
          <div className="flex">
            <img
              src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178679/ljnisdvkwrq0zixpk7jr.png"
              alt="Play"
              className="h-10"
            />
            <Link to="../relaxation29">
              <img
                src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178884/aqhhjahhkpg9fegczzjy.png"
                alt="Close"
                className="h-10"
              />
            </Link>
            <img
              src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178679/pxsqwr0jy4y6vxacud4y.png"
              alt="Home"
              className="h-12"
            />
          </div>
        </div>
      </main>
    </section>
  );
};

export default Relaxation28;
